import { Component } from 'react';
import styled from 'styled-components';

import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import { SportsItemStyle } from './sportsCommonStyle';

interface IProps {
  url: string;
  name: string;
  dataClParams: string;
}

const SoccerItem = styled.li`
  ${SportsItemStyle}
`;

const SoccerLink = styled.a`
  ${pcVisitedLink}
`;

export default class SoccerPlayer extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <SoccerItem>
        <SoccerLink href={this.props.url} data-cl-params={this.props.dataClParams}>
          {this.props.name}
        </SoccerLink>
      </SoccerItem>
    );
  }
}
